import {
  DistributionHttpHeaders,
  JUFAIR_PARTNER_REF_KEY,
  JUFAIR_SHARE_CHANNEL_KEY,
  normalizePartnerRef,
  pickShareChannelFromQuery
} from '~/utils/partnerRef'

/**
 * URL ?ref= / ?partnerCode= 写入 Cookie + localStorage（30 天），供后续请求头透传；
 * 同次带 ref 的访问同步 ?shareChannel=（无该参数则清除已存渠道，避免旧渠道污染新推广链）。
 */
export default defineNuxtRouteMiddleware(to => {
  const raw =
    to.query[DistributionHttpHeaders.REF] ?? to.query.partnerCode ?? to.query.partnerRef
  const first = Array.isArray(raw) ? raw[0] : raw
  const v = normalizePartnerRef(first)
  if (!v) {
    return
  }
  const cookie = useCookie(JUFAIR_PARTNER_REF_KEY, {
    maxAge: 60 * 60 * 24 * 30,
    path: '/',
    sameSite: 'lax'
  })
  cookie.value = v
  if (import.meta.client) {
    try {
      localStorage.setItem(JUFAIR_PARTNER_REF_KEY, v)
    } catch {
      /* ignore */
    }
  }

  const ch = pickShareChannelFromQuery(to.query as Record<string, unknown>)
  const chCookie = useCookie<string | null>(JUFAIR_SHARE_CHANNEL_KEY, {
    maxAge: 60 * 60 * 24 * 30,
    path: '/',
    sameSite: 'lax'
  })
  if (ch) {
    chCookie.value = ch
    if (import.meta.client) {
      try {
        localStorage.setItem(JUFAIR_SHARE_CHANNEL_KEY, ch)
      } catch {
        /* ignore */
      }
    }
  } else {
    chCookie.value = null
    if (import.meta.client) {
      try {
        localStorage.removeItem(JUFAIR_SHARE_CHANNEL_KEY)
      } catch {
        /* ignore */
      }
    }
  }
})
